import { render, staticRenderFns } from "./Competencies.vue?vue&type=template&id=21a842aa&"
import script from "./Competencies.vue?vue&type=script&lang=js&"
export * from "./Competencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports